export const Entity = {
  USER: 'user',
  CHANNEL: 'channel',
  ORDER: 'order',
  FILE: 'file',
  DEAL_ROOM: 'dealRoom',
  DEAL_ROOM_MENU: 'dealRoomMenu',
  CLIENT: 'client',
};
